import { Drawer } from 'components/Drawer'
import { DrawerProps } from 'components/Drawer/Root'
import { observer } from 'mobx-react-lite'
import { ShareSheetV2, ShareSheetV2Props } from '../ShareSheetV2'

export const ShareSheetDrawer = observer(
  ({ file, initialPermission, initialRecipients, ...props }: DrawerProps & ShareSheetV2Props) => {
    return (
      <Drawer.Root {...props}>
        <Drawer.Portal>
          <Drawer.Content fullHeight>
            <Drawer.InnerContent isSnappedTop>
              <Drawer.Container padding="0px">
                <ShareSheetV2 file={file} initialPermission={initialPermission} initialRecipients={initialRecipients} />
              </Drawer.Container>
            </Drawer.InnerContent>
          </Drawer.Content>
          <Drawer.Overlay />
        </Drawer.Portal>
      </Drawer.Root>
    )
  },
)
